import { Component, OnInit } from '@angular/core';

import { PageStructure } from '../types/pageStructure';

import * as pageStructure from '../../assets/general/pageStructure.json';


@Component({
  selector: 'app-natural-enemies',
  templateUrl: './natural-enemies.component.html',
  styleUrls: ['./natural-enemies.component.css']
})
export class NaturalEnemiesComponent implements OnInit {

  public pageContent: PageStructure;

  public carouselData = Array();
  public carouselTitle = '';

  private pages: PageStructure[] = Array();

  constructor(
  ) { }

  public loadCarousel(itemTitle, carouselData) {
    this.carouselTitle = this.pageContent.title + ' - ' + itemTitle;
    this.carouselData = carouselData;
  }

  ngOnInit() {

    this.pages = (<any>pageStructure).pages;

    const selectedPage = this.pages;

    selectedPage.forEach(element => {

      if (element.page === 'naturalenemies') {
        this.pageContent = element;
      }
    });

  }

}
